import { Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import InfoSection from "@quest_editor/components/InfoSection";
import { Promotion } from "@quest_editor/mocks";

const SourceInfoSection = ({
  promotion,
  getTypeLabel,
  buildOptionsDisplay,
}: {
  promotion: Promotion;
  getTypeLabel: (type: string) => string;
  buildOptionsDisplay: (promotion: Promotion | null | undefined) => string[];
}) => {
  const { t } = useTranslation("questEditor");

  return (
    <InfoSection
      title={t("promotion_duplication.section.source")}
      rows={[
        {
          label: t("promotion_duplication.field.id"),
          children: <Typography color="primary">{promotion.id}</Typography>,
        },
        {
          label: t("promotion_duplication.field.promotion_name"),
          children: <Typography color="primary">{promotion.name}</Typography>,
        },
        {
          label: t("promotion_duplication.field.type"),
          children: (
            <Typography color="primary">
              {getTypeLabel(promotion.type)}
            </Typography>
          ),
        },
        {
          label: t("promotion_duplication.field.description"),
          children: (
            <Typography color="primary" sx={{ whiteSpace: "pre-wrap" }}>
              {promotion.description}
            </Typography>
          ),
        },
        {
          label: t("promotion_duplication.field.options"),
          children: (
            <Stack direction="column" spacing={0.5}>
              {buildOptionsDisplay(promotion).map(
                (option: string, index: number) => (
                  <Typography color="primary" key={index}>
                    {option}
                  </Typography>
                ),
              )}
            </Stack>
          ),
        },
      ]}
    />
  );
};

export default SourceInfoSection;
